import getApolloClient from "shared/util/getApolloClient";
import { STACK_QUERY, JUST_FOR_YOU_QUERY } from "apps/quickmatch/util/queries";
import { STACKS } from "apps/quickmatch/util/constants";

/**
 * This function fetches data from graphql.
 * @param {string} userId - Current user id.
 * @param {string} stackId - The stack id to fetch.
 * @param {Array} excludedUserIds - The list of userIds to exclude from a stack.
 */
export default async function getStack(userId, stackId, excludedUserIds) {
	const apolloClient = getApolloClient();
	const { data } = await apolloClient.query({
		query: stackId === STACKS.JUST_FOR_YOU
			? JUST_FOR_YOU_QUERY
			: STACK_QUERY,
		variables: {
			userId,
			stackId,
			excludedUserIds,
		},
	});

	return data;
}



// WEBPACK FOOTER //
// ./src/apps/quickmatch/util/getStack.js